import React from 'react';

const Icon74ChaiseOrientationLeft = props => (
  <svg
    focusable="false"
    viewBox="0 0 800 800"
    aria-hidden="true"
    role="presentation"
    {...props}
  >
    <g>
      <path
        d="M174.1,255.49h32.67v259.82c0,5.07-4.11,9.18-9.18,9.18h-23.49c-5.07,0-9.18-4.11-9.18-9.18v-250.64c0-5.07,4.11-9.18,9.18-9.18Z"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M215.77,255.49h207.75s0,0,0,0h53.9c4.97,0,9,4.03,9,9v43.25h-62.9s0,0,0,0h-216.75v-43.25c0-4.97,4.03-9,9-9Z"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
    </g>
    <path
      d="M635.08,316.74v198.75c0,4.97-4.03,9-9,9H206.77v-216.75h419.3c4.97,0,9,4.03,9,9Z"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
  </svg>
);

export default Icon74ChaiseOrientationLeft;
